import {CdAimEvaluationReasonFactory} from './cd-aim-evaluation-reason-factory';
import {LightUser} from '../../../interfaces/core/light-user';
import {LightUserFactory} from '../../core/light-user-factory';
import {CdAimEvaluation} from '../../../interfaces/care/cd-care-plan/cd-aim-evaluation';
import {CdAimEvaluationReason} from '../../../interfaces/care/cd-care-plan/cd-aim-evaluation-reason';
import {UserService} from '../../../services/core/user.service';
import {CdAimEvaluationOrderOption} from '../../../interfaces/care/cd-care-plan/cd-aim-evaluation-order-option';
import {CdAimEvaluationOrderOptionFactory} from './cd-aim-evaluation-order-option.factory';

export class CdAimEvaluationFactory {

  /**
   *
   * @param cdAimEvaluation
   */
  public static fromObject(cdAimEvaluation: any): CdAimEvaluation {
    return new class implements CdAimEvaluation {
      cdAddedAimId: number = cdAimEvaluation.c_care_plan_item_id;
      cdAimEvaluationReasonId: number = cdAimEvaluation.c_evaluation_reason_id;
      cdAimEvaluationScaleId: number = cdAimEvaluation.nanda_evaluation_scale_id;
      cdAimEvaluationScaleText: string = cdAimEvaluation.nanda_evaluation_scale_text;
      cdAimEvaluationScaleValue: number = cdAimEvaluation.nanda_evaluation_scale_value;
      comment: string = cdAimEvaluation.comment;
      nextAppointment: string = cdAimEvaluation.next_appointment;
      setAimFinished: boolean = cdAimEvaluation.set_aim_finished;
      date: string = cdAimEvaluation.date;
      user: LightUser = LightUserFactory.fromObject(cdAimEvaluation.user);
      cdAimEvaluationReason: CdAimEvaluationReason =
        cdAimEvaluation.c_evaluation_reason ? CdAimEvaluationReasonFactory.fromObject(cdAimEvaluation.c_evaluation_reason) : null;
      cdAimEvaluationOrderOptionId: number = cdAimEvaluation.c_evaluation_order_option_id;
      cdAimEvaluationOrderOption: CdAimEvaluationOrderOption =
        cdAimEvaluation.c_evaluation_order_option ?
          CdAimEvaluationOrderOptionFactory.fromObject(cdAimEvaluation.c_evaluation_order_option) : null;
      evaluationOrder: string = cdAimEvaluation.evaluation_order;

      // ------------------------------------------------------------------------------------------------
      id: number = cdAimEvaluation.id;
      deleted: 0 | 1 = 0;
      uuid: string = cdAimEvaluation.uuid;
      modified: string = cdAimEvaluation.modified;
      created: string = cdAimEvaluation.created;
    };
  }

  /**
   *
   */
  public static new(): CdAimEvaluation {
    return new class implements CdAimEvaluation {
      cdAddedAimId: number = null;
      cdAimEvaluationReasonId: number = null;
      cdAimEvaluationScaleId: number = null;
      cdAimEvaluationScaleText: string = null;
      cdAimEvaluationScaleValue: number = null;
      comment: string = null;
      nextAppointment: string = null;
      setAimFinished: boolean = null;
      date: string = null;
      user: LightUser = LightUserFactory.fromUser(UserService.getUser());
      cdAimEvaluationReason: CdAimEvaluationReason = null;
      cdAimEvaluationOrderOptionId: number = null;
      cdAimEvaluationOrderOption: CdAimEvaluationOrderOption = null;
      evaluationOrder: string = null;

      // ------------------------------------------------------------------------------------------------
      id: number = null;
      deleted: 0 | 1 = 0;
      uuid: string = null;
      modified: string = null;
      created: string = null;
    };
  }

  /**
   *
   * @param cdAimEvaluations
   */
  public static fromArray(cdAimEvaluations: any[]): CdAimEvaluation[] {
    return cdAimEvaluations.map(cdAimEvaluation => CdAimEvaluationFactory.fromObject(cdAimEvaluation));
  }

  /**
   *
   * @param cdAimEvaluation
   */
  public static toRemote(cdAimEvaluation: CdAimEvaluation): any {
    return {
      c_care_plan_item_id: cdAimEvaluation.cdAddedAimId,
      date: cdAimEvaluation.date,
      nanda_evaluation_scale_id: cdAimEvaluation.cdAimEvaluationScaleId,
      nanda_evaluation_scale_value: cdAimEvaluation.cdAimEvaluationScaleValue,
      nanda_evaluation_scale_text: cdAimEvaluation.cdAimEvaluationScaleText,
      c_evaluation_reason_id: cdAimEvaluation.cdAimEvaluationReasonId,
      comment: cdAimEvaluation.comment,
      set_aim_finished: cdAimEvaluation.setAimFinished,
      next_appointment: cdAimEvaluation.nextAppointment,
      uuid: cdAimEvaluation.uuid,
      c_evaluation_order_option_id: cdAimEvaluation.cdAimEvaluationOrderOptionId,
      evaluation_order: cdAimEvaluation.evaluationOrder
    };
  }

}
